import { createUrl } from './create-url';

const isFeatureOrSecurityEnv = (url: string): boolean =>
    /ifmypagesexternal.*\.azurewebsites\.net/.test(url);

const isMyPagesUrl = (url: string): boolean =>
    /minesider\.if\.no/.test(url) ||
    /omatsivut\.if\.fi/.test(url) ||
    /minasidor\.if\.fi/.test(url) ||
    /minasidor\.if\.se/.test(url) ||
    /minesider\.if\.dk/.test(url) ||
    /\.mypages\.ifext\./.test(url) ||
    isFeatureOrSecurityEnv(url);

const isLoginPage = (url: string): boolean =>
    /\/kirjaudu\//.test(url) ||
    /\/loggain\//.test(url) ||
    /\/inloggning\//.test(url) ||
    /\/innlogging\//.test(url) ||
    /\/log-ind\//.test(url);

const isLogoutPage = (url: string): boolean =>
    /\/kirjaudu_ulos\//.test(url) ||
    /\/logga-ut\//.test(url) ||
    /\/utloggning\//.test(url) ||
    /\/logget-ut\//.test(url) ||
    /\/log_ud\//.test(url);

export const getMyPagesUrl = (url: string): string => {
    const page = createUrl(url);
    if (!page) return '';

    const hostname = page.hostname;
    const href = page.href;

    if (isMyPagesUrl(hostname) && !isLoginPage(href) && !isLogoutPage(href)) {
        return page.origin;
    }

    return '';
};
